import type { ReactElement } from "react";

import { PrimaryHomepage } from "@similarweb/ui-components";

import { DEFAULT_HOMEPAGE_PREFERENCE_KEY } from "app/components/modals/constants";
import { DefaultHomePageModal } from "app/components/modals/DefaultHomePageModal";
import ScrollToTopWrapper from "app/pages/sales-intelligence/common-components/ScrollToTopWrapper/ScrollToTopWrapper";
import { useOpenImpactReportFromRouteParam } from "app/pages/sales-intelligence/modules/industry/hooks/useOpenImpactReportFromRouteParam";
import { useShowsIndustryTaxonomyHomeBanner } from "app/pages/sales-intelligence/modules/industry/hooks/useShowsIndustryTaxonomyHomeBanner";
import IntentApprovalContainer from "app/pages/sales-intelligence/sub-modules/intent/components/IntentApprovalContainer";
import { PreferencesService } from "app/services/preferences/preferencesService";

import HomepageCompaniesSearch from "./components/HomepageCompaniesSearch/HomepageCompaniesSearch";
import HomePageHeaderBackground from "./components/HomePageHeaderBackground/HomePageHeaderBackground";
import HomePageTitle from "./components/HomePageTitle/HomePageTitle";
import NoTouchAddonBanner from "./components/NoTouchAddonBanner/NoTouchAddonBanner";
import HomePageContent from "./containers/HomePageContent/HomePageContent";
import { StyledHomepageWrapper, StyledPrimaryHomepageWrapper } from "./styles";
import type { HomePageContainerProps } from "./types/models";

const HomePage = ({ opportunityLists, hasPageBeenVisited }: HomePageContainerProps): ReactElement => {
    const defaultHomepage = PreferencesService.get(DEFAULT_HOMEPAGE_PREFERENCE_KEY);

    useOpenImpactReportFromRouteParam();
    const showsIndustryTaxonomyHomeBanner = useShowsIndustryTaxonomyHomeBanner();

    return (
        <ScrollToTopWrapper>
            <StyledHomepageWrapper>
                {showsIndustryTaxonomyHomeBanner ? null : <NoTouchAddonBanner />}
            </StyledHomepageWrapper>

            <StyledPrimaryHomepageWrapper>
                <PrimaryHomepage
                    subtitlePosition="left-aligned"
                    headerBackgroundColor="transparent"
                    searchComponents={<HomepageCompaniesSearch />}
                    title={
                        <HomePageTitle
                            defaultHomepage={defaultHomepage}
                            hasPageBeenVisited={hasPageBeenVisited}
                        />
                    }
                    usecaseItems={<HomePageContent opportunityLists={opportunityLists} />}
                />
            </StyledPrimaryHomepageWrapper>

            <>
                <HomePageHeaderBackground />

                <DefaultHomePageModal defaultHomepage={defaultHomepage} />
                <IntentApprovalContainer />
            </>
        </ScrollToTopWrapper>
    );
};

export default HomePage;
